import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {MQMatchingQuestion} from '../../models';
import {StudentDndMatchingQuestion} from './StudentDndMatchingQuestion';
import {StudentDropdownMatchingQuestion} from './StudentDropdownMatchingQuestion';

interface PropsType {
  x9: X9Content | X9ContentSnapshot;
  store: X9ContentStateStore;
  lessonType?: string;
}

@observer
export class StudentMatchingQuestion extends React.Component<PropsType> {
  constructor(props: PropsType) {
    super(props);
    makeObservable(this);
  }

  @computed
  get model(): MQMatchingQuestion {
    return JSON.parse(this.props.x9.Contents) as MQMatchingQuestion;
  }

  render() {
    const behavior = this.model.options.behavior;

    if (behavior === 'dropdown')
      return (
        <StudentDropdownMatchingQuestion id={this.props.x9.Id}
                                         question={this.model}
                                         store={this.props.store}
                                         lessonType={this.props.lessonType}/>);

    if (behavior === 'dragdrop')
      return (
        <StudentDndMatchingQuestion id={this.props.x9.Id}
                                    question={this.model}
                                    store={this.props.store}
                                    lessonType={this.props.lessonType}/>);

    return null;
  }
}
